export const defaultBaseUrl = "http://127.0.0.1:8180";
export const defaultRealm = "master";
//# sourceMappingURL=constants.js.map